import {
  SET_SEARCH_PARAMS_EXCHANGE_CERTIFICATES,
  GET_DATA_BY_SEARCH_PARAMS_EXCHANGE_CERTIFICATES,
  ADD_NEW_DATA_EXCHANGE_CERTIFICATES,
  GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE,
  CLEAR_EXCHANGE_APP_DATA,
  GET_EXCHANGE_APP_BY_ID,
} from "../types";
const initialState = {
  data: [],
  searchParams: {
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    section: 0,
    status: 0,
    licenseNum: "",
    licenseDate: "",
    licenseType: 0,
  },
  wrongTypeErr: false,
  licenseNotExistErr: false,
  newAppExchangeCertificates: {},
};

export const exchangeCertificatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_PARAMS_EXCHANGE_CERTIFICATES:
      return {
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      };
    case GET_DATA_BY_SEARCH_PARAMS_EXCHANGE_CERTIFICATES:
      return {
        ...state,
        data: action.data,
      };
    // case GET_DATA_APPLICANT_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES:
    //   return {
    //     ...state,
    //     dataApplicants: [...action.data],
    //   };
    case ADD_NEW_DATA_EXCHANGE_CERTIFICATES:
      return {
        ...state,
        newAppExchangeCertificates: {
          ...state.newAppExchangeCertificates,
          ...action.data,
        },
      };
    case GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE:
      return {
        ...state,
        newAppExchangeCertificates: { ...action.data.response },
        wrongTypeErr: action.data.wrongTypeErr,
        licenseNotExistErr: action.data.licenseNotExistErr,
      };
    case CLEAR_EXCHANGE_APP_DATA:
      return {
        ...state,
        newAppExchangeCertificates: { ...{}, ...action.data },
        wrongTypeErr: false,
        licenseNotExistErr: false,
      };
    case GET_EXCHANGE_APP_BY_ID:
      return {
        ...state,
        newAppExchangeCertificates: action.data,
      };
    default:
      return state;
  }
};
